import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Diamond } from '@sorare/core/src/components/rivals/branded/Diamond';

import { GroupAvatar_rivalsUserGroup } from './__generated__/index.graphql';

type Props = {
  userGroup?: Nullable<GroupAvatar_rivalsUserGroup>;
  className?: string;
  size?: 'sm' | 'md' | number;
};

const Img = styled.img`
  object-fit: cover;
`;

export const GroupAvatar = ({ userGroup, className, size = 'md' }: Props) => {
  let imageSize = size === 'sm' ? 42 : 80;
  if (typeof size === 'number') {
    imageSize = size;
  }
  if (!userGroup?.logo?.pictureUrl) {
    return (
      <Diamond
        width={imageSize}
        height={imageSize}
        color="var(--c-rivals-purple)"
        className={className}
      />
    );
  }
  return (
    <Img
      src={userGroup.logo.pictureUrl}
      alt=""
      width={imageSize}
      className={className}
      style={{
        minHeight: `${imageSize}px`,
      }}
    />
  );
};

GroupAvatar.fragments = {
  rivalsUserGroup: gql`
    fragment GroupAvatar_rivalsUserGroup on RivalsUserGroup {
      slug
      logo {
        id
        pictureUrl
      }
    }
  ` as TypedDocumentNode<GroupAvatar_rivalsUserGroup>,
};
